import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'shared/lib';

import { selectUniqVitrinsOffers } from 'entities/vitrins';

import { fetchVitrinsThunk } from 'features/VitrinsOffers/lib/fetchVitrinsOffersThunk';

export const useFetchVitrinsOffersData = () => {
  const dispatch = useDispatch();
  const offers = useAppSelector(selectUniqVitrinsOffers);

  useEffect(() => {
    dispatch(fetchVitrinsThunk());
  }, [dispatch]);

  return offers;
};
